import React from 'react';
import HierarchicalLocationList from './HierarchicalLocationList';

const LocationsPage: React.FC = () => <HierarchicalLocationList />;

export default LocationsPage;
